import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, AlertCircle, CheckCircle } from 'lucide-react';
import { api } from '../../lib/api';

export function ResetPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await api.post('/api/auth/request-reset', { email });
      setSuccess(true);
    } catch (err: any) {
      setError(err.message || 'リクエストの送信に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="animate-fadeIn">
        <div
          className="card p-8 text-center"
          style={{
            backgroundColor: 'var(--background-card)',
            borderColor: 'var(--border-color)',
          }}
        >
          <div className="w-16 h-16 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center mx-auto mb-4">
            <CheckCircle className="text-green-600" size={32} />
          </div>
          <h2
            className="text-xl font-bold mb-2"
            style={{ color: 'var(--text-primary)' }}
          >
            メールを送信しました
          </h2>
          <p className="mb-6" style={{ color: 'var(--text-secondary)' }}>
            パスワードリセットの手順を記載したメールを
            <br />
            <strong>{email}</strong> に送信しました。
          </p>
          <Link
            to="/login"
            className="inline-flex items-center gap-2 text-sm hover:underline"
            style={{ color: 'var(--accent-color)' }}
          >
            <ArrowLeft size={16} />
            ログイン画面に戻る
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="animate-fadeIn">
      <div
        className="card p-8"
        style={{
          backgroundColor: 'var(--background-card)',
          borderColor: 'var(--border-color)',
        }}
      >
        <Link
          to="/login"
          className="inline-flex items-center gap-1 text-sm mb-6 hover:underline"
          style={{ color: 'var(--text-secondary)' }}
        >
          <ArrowLeft size={16} />
          ログインに戻る
        </Link>

        <h2
          className="text-2xl font-bold mb-2"
          style={{ color: 'var(--text-primary)' }}
        >
          パスワードリセット
        </h2>
        <p className="mb-6" style={{ color: 'var(--text-secondary)' }}>
          登録済みのメールアドレスを入力してください。
          パスワードリセットのリンクをお送りします。
        </p>

        {error && (
          <div className="mb-4 p-3 rounded-lg bg-red-50 dark:bg-red-900/20 flex items-center gap-2 text-red-600">
            <AlertCircle size={18} />
            <span className="text-sm">{error}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              className="block text-sm font-medium mb-1.5"
              style={{ color: 'var(--text-primary)' }}
            >
              メールアドレス
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-2.5 rounded-lg border transition-colors"
              style={{
                backgroundColor: 'var(--input-bg)',
                borderColor: 'var(--input-border)',
                color: 'var(--text-primary)',
              }}
              placeholder="you@example.com"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-white font-medium transition-colors disabled:opacity-50"
            style={{ backgroundColor: 'var(--accent-color)' }}
          >
            {loading ? (
              <span className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            ) : (
              <>
                <Mail size={18} />
                リセットメールを送信
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}

